﻿import React, {FC} from 'react';
import {Box} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '16px',
  color: 'white',
  fontWeight: 'bold',
  fontSize: '20px',
}));

type CollapsableCardInfoBannerProps = React.ComponentPropsWithoutRef<'div'> & {
  message?: string | undefined
}

const CollapsableCardInfoBanner: FC<CollapsableCardInfoBannerProps> = ({
  message,
  ...rest
}) => {

  return !!message && <Root {...rest}>
    {message}
  </Root>
}

export { CollapsableCardInfoBanner };
